import { Container } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { AlertTitle, Box } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const ErrorMessage = ({ error }) => {
  return (
    <Box p={1}>
      <Container fixed>
        <Alert severity="error">
          <AlertTitle style={{ fontWeight: 'bold', fontFamily: 'monospace' }}>
            Unexpected error occurred!
          </AlertTitle>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <code>{error.toString()}</code>
             {error.sentryEventId && (<code>Error ID: {error.sentryEventId}</code>)}
          </div>
        </Alert>
      </Container>
    </Box>
  )
}

ErrorMessage.propTypes = {
  error: PropTypes.instanceOf(Error).isRequired,
}

export default ErrorMessage
